export const AUTH_RESET_2FA = 'AUTH_RESET_2FA'
export const AUTH_RESET_2FA_SUCCESS = 'AUTH_RESET_2FA_SUCCESS'
export const AUTH_RESET_2FA_FAILED = 'AUTH_RESET_2FA_FAILED'
